// extracted by mini-css-extract-plugin
export default {"card":"D2-z"};